import {
	ADDITIONAL_DRIVER_MOTORING_CLAIMS_ERRORS,
	MOTORING_CLAIMS_ERRORS,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import * as Yup from 'yup';

export const getMotoringClaimsSchema = (isAdditionalDriver: boolean) => {
	const errorMessageObject = isAdditionalDriver ? ADDITIONAL_DRIVER_MOTORING_CLAIMS_ERRORS : MOTORING_CLAIMS_ERRORS;

	return Yup.object().shape({
		dateOfClaim: Yup.object().shape({
			day: Yup.string().required(errorMessageObject.dateOfClaim),
			month: Yup.string().required(errorMessageObject.dateOfClaim),
			year: Yup.string().required(errorMessageObject.dateOfClaim),
		}),
		typeOfClaim: Yup.string().required(errorMessageObject.typeOfClaim),
		statusOfClaim: Yup.string().required(errorMessageObject.statusOfClaim),
		atFault: Yup.string().required(errorMessageObject.atFault),
		noClaimsBonusAffected: Yup.string().required(errorMessageObject.noClaimsBonusAffected),
		costOfClaim: Yup.number()
			.min(0, errorMessageObject.costOfClaimGreaterOrEqualToZero)
			.required(errorMessageObject.costOfClaim),
	});
};

export default getMotoringClaimsSchema(false);
